import { createApp } from 'vue';
import PdfToEpubConverter from '@/Components/PdfToEpubConverter.vue';
import '@styles/app.css';

createApp(PdfToEpubConverter).mount('#pdf-to-epub-converter');
